export default __webpack_public_path__ + "static/media/exclamation-outline.9eee33ee.svg";